<td>
  {{ idx }}
</td>
<td>
  {{ item.title }}
</td>
<td>
  {{ item.duration | secondsToMinutes | playerExtraCutPipe}}
</td>
